import Table from "../table/Table";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../coreComponents/CommonCardHeader";
import { useAppSelector } from "../../reduxToolkit/hooks";
import { useCallback, useEffect, useState } from "react";
import { usePagination } from "../../hooks/usePagination";
import FilterIcon from "../svg/FilterIcon";
import {
  Button,
  Card,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "../lodingComponent";
import LeftIcon from "../svg/LeftButton";
import RightIcon from "../svg/RightIcon";
import ApiService from "../../services/apiService";
import { method } from "lodash";
import { toast } from "react-toastify";
import { format } from "date-fns";
import DateTimePicker from "react-datepicker";
import ExportExcel from "../reports/ExportExcel";
const PowerConsumption = () => {
  const role = useAppSelector((state: any) => state.role.role);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<string | number>();
  const [isEnabled, setIsEnabled] = useState<boolean>(false);
  const [fromDateTime, setFromDateTime] = useState(null);
  const [toDateTime, setToDateTime] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [pumpingStationData, setPumpingStationData] = useState<any[]>();
  const [selectedStationName, setSelectedStationName] = useState<string>();
  let updatedData: any = []
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const {
    data,
    pageNumber,
    setPageNumber,
    pageSize,
    totalCount,
    setRefresh,
    searchQuery,
    setSearchQuery,
    filterOn,
    setSortBy,
    loading,
    setPumpingStationId,
    setFromDate,
    setToDate,
    fromDate,toDate
  } = usePagination({
    endpoint: `/powerconsumption`,
    enabled: isEnabled,
  });

  const totalPages = Math.ceil(totalCount / pageSize);

  const handleNext = useCallback(() => {
    setPageNumber((prev) => Math.min(totalPages, prev + 1));
  }, [setPageNumber, totalPages]);

  const handlePrev = useCallback(() => {
    setPageNumber((prev) => Math.max(1, prev - 1));
  }, [setPageNumber, totalPages]);

  useEffect(() => {
    const updatedData = data.map((power: any) => {
      return format(power.dateTime, "yyyy-MM-dd HH:mm:ss");
    });
  }, [data]);

  useEffect(() => {
    const GetPumpingStation = async () => {
      try {
        const response = await ApiService.axiosApi(`/pumpingstation`, {
          method: "GET",
          params: {
            pageNumber: 0,
            pageSize: 0,
          },
        });
        if (response.success) {
          setPumpingStationData(response.data.data);
        } else {
          console.log(
            response.message ||
              response.status ||
              "Unable To Get Pumping Station"
          );
        }
      } catch (error) {
        console.log(error);
      }
    };

    GetPumpingStation();
  }, []);

  const handleUpdate = (id: string) => {
    navigate(`/power-consumption-update/${id}`);
  };

  const handleDelete = (id: string) => {
    setSelectedId(id);
    setIsModalOpen(true);
  };

  const handleDeleteConfirm = async (id: string | number | undefined) => {
    try {
      const response = await ApiService.axiosApi(`/powerconsumption/${id}`, {
        method: "DELETE",
      });
      if (response.success) {
        toast.success("Power Consumption Deleted Successfully");
        setIsModalOpen(false);
        setRefresh((prev) => !prev);
      } else {
        toast.error("Unable to Delete Power Consumption");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClick = () => {
    if (!validateGenerate()) return;
    if (fromDateTime) {
      const from = format(fromDateTime, "yyyy-MM-dd HH:mm:ss");
      setFromDate(from);
    }

    if (toDateTime) {
      const to = format(toDateTime, "yyyy-MM-dd HH:mm:ss");
      setToDate(to);
    }

    setIsEnabled(true);
    setRefresh((prev) => !prev);
  };

  if (data) {
    updatedData = data.map((data) => {
      return {
        ...data,
        dateTime: format(new Date(data.dateTime), "dd-MM-yyyy HH:mm:ss"),
      };
    });
  }
  const validateGenerate = () => {
    
  
    
    if (!fromDateTime) {
      toast.warning("Please select From Date");
      return false;
    }
  
    if (!toDateTime) {
      toast.warning("Please select To Date");
      return false;
    }
  
    if (new Date(fromDateTime) > new Date(toDateTime)) {
      toast.warning("From Date cannot be greater than To Date");
      return false;
    }
  
    return true;
  };
  const fetchAllDataForExport = async () => {
    try {
      const response = await ApiService.axiosApi(`/powerconsumption`, {
        method: "GET",
        params: {
          pageNumber: 0,
          pageSize: 0,
        // selected Chak ID
          fromDate: fromDate,
          toDate: toDate,
          // <-- fetch ALL rows
        },
      });

      if (response.success) {
        return response.data.data;
      } else {
        toast.error("Unable to fetch full report");
        return [];
      }
    } catch (error) {
      console.log(error);
      toast.error("API Error");
      return [];
    }
  };

  return (
    <>
      <Breadcrumbs mainTitle="Power Consumption" parent="Power Consumption" />
      <div className="w-100 bg-white px-2 py-2">
        <div
          className="bg-light-primary "
          style={{
            width: "100%",
            height: "100px",
            border: "1px solid rgb(43, 94, 94, 0.1)",
          }}
        >
          <div className="d-flex justify-content-between align-items-center report-header">
            <div className="powerconsumptionreport-dropdowndatetime d-flex justify-content-between">
              <div className="report-input-div mx-4 input-border d-flex flex-column "style={{width:'50%'}}>
                <Label>From Date:</Label>
                <DateTimePicker
                  className="powerconsumptionreport-fromdate"
                  dateFormat="dd/MM/yyyy HH:mm:ss"
                  placeholderText="DD-MM-YYYY"
                  showTimeSelect
                  onChange={(date: any) => setFromDateTime(date)}
                  selected={fromDateTime}
                  isClearable
                  timeFormat="HH:mm:ss"
                />
              </div>

              <div className="report-input-div mx-4  input-border  d-flex flex-column"style={{width:'50%'}}>
                <Label>To Date:</Label>
                <DateTimePicker
                  className="powerconsumptionreport-todate"
                  dateFormat="dd/MM/yyyy HH:mm:ss"
                  placeholderText="DD-MM-YYYY"
                  showTimeSelect
                  onChange={(date: any) => setToDateTime(date)}
                  selected={toDateTime}
                  isClearable
                  timeFormat="HH:mm:ss"
                />
              </div>
            </div>
            <div className=" d-flex  powerconsumption-buttonclass gap-3">
                <div className="d-flex flex-column"style={{width:'30%'}}>
              <Label style={{ visibility: "hidden" }}>Generate</Label>
              <Button className="px-0" color="success" onClick={handleClick} style={{width:'100%'}}>
                Generate
              </Button>
              </div>

                   <div className=" d-flex flex-column" style={{width:'30%'}}>
                        <Label style={{ visibility: 'hidden' }}>Generate</Label>
                        <Button className="px-0" style={{width:'100%'}} onClick={() => navigate(`/power-consumption-add`)} color="primary">
                            Add
                        </Button>
                    </div>
                
                <ExportExcel getData={fetchAllDataForExport} fileName="Power_Consumption_Report" style={{width:'30%'}} EffectiveFrom={fromDate} toDate={toDate} hiddenColumns={['id','pumpingStationId','name']}/>
                 
            </div>
          </div>
        </div>

        <div className="mt-2">
          <Table
            isAction={true}
            data={updatedData}
            columns={[
                { header: "Date&Time", accessor: "dateTime" },
             
              {
                header: "Power Consumption(kWh)",
                accessor: "powerConsumption_KWH",
              },
              
            ]}
            buttons={[
              {
                label: "Edit",
                onClick: handleUpdate,
                color: "primary",
                className: "me-2",
              },
              { label: "Delete", onClick: handleDelete, color: "danger" },
            ]}
          />
        </div>

        <div
          className=" d-flex justify-content-end align-content-center"
          style={{ marginRight: "10px", marginTop: "10px" }}
        >
          <p style={{ marginRight: "10px", marginTop: "8px" }}>
            Page {pageNumber} of {totalPages}
          </p>
          <button
            onClick={handlePrev}
            disabled={pageNumber === 1}
            className={`icon-button ${
              pageNumber === totalPages ? `icon-button` : ""
            }`}
          >
            <LeftIcon className="icon" />
          </button>
          <button
            className={`icon-button ${
              pageNumber === totalPages ? "disabled" : ""
            }`}
            onClick={handleNext}
            disabled={pageNumber === totalPages}
          >
            <RightIcon className="icon" />
          </button>
        </div>
      </div>
    

      
    </>
  );
};

export default PowerConsumption;
